import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { useSnackbar } from 'notistack';
import { supportEmailTemplateProps } from 'shared/utility';

export function useSendSupportEmail() {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<void, Error, supportEmailTemplateProps>(
    request => quoteService.sendSupportEmail(request),
    {
      onSuccess: () => {
        enqueueSnackbar('Feedback email sent', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('Failed to send feedback email', { variant: 'error' });
      },
    }
  );
  return mutation;
}
